import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';

const CONSENT_KEY = 'assietica-cookie-consent';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(CONSENT_KEY)) setVisible(true);
    } catch {}
    const open = () => setVisible(true);
    window.addEventListener('open-cookie-banner', open);
    return () => window.removeEventListener('open-cookie-banner', open);
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    if (window.__initPostHog) window.__initPostHog();
    if (window.posthog && window.posthog.opt_in_capturing) window.posthog.opt_in_capturing();
    setVisible(false);
  };

  const reject = () => {
    localStorage.setItem(CONSENT_KEY, 'rejected');
    if (window.__posthogInitialized && window.posthog && window.posthog.opt_out_capturing) {
      window.posthog.opt_out_capturing();
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-[70] p-4 sm:p-5"
    >
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-2xl border border-gray-200 p-5 sm:p-6">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4">
          <div className="flex items-start gap-3 flex-1">
            <div className="w-10 h-10 rounded-xl bg-[#F9D424]/20 flex items-center justify-center flex-shrink-0">
              <Cookie size={20} className="text-[#E67E22]" />
            </div>
            <p className="text-sm text-gray-700 leading-relaxed">
              Questo sito utilizza cookie tecnici necessari al funzionamento e, previo tuo consenso,
              cookie analitici (PostHog) per statistiche di navigazione. Puoi accettare tutti i cookie
              o proseguire con i soli cookie tecnici. Maggiori dettagli nella{' '}
              <Link to="/cookie-policy" className="text-[#2B7A9F] underline font-medium">
                Cookie Policy
              </Link>.
            </p>
          </div>
          <div className="flex gap-3 flex-shrink-0">
            <button
              data-testid="cookie-reject-btn"
              onClick={reject}
              className="px-4 py-2.5 rounded-lg border border-gray-300 text-gray-700 text-sm font-semibold hover:bg-gray-50 transition-colors duration-300"
            >
              Solo tecnici
            </button>
            <button
              data-testid="cookie-accept-btn"
              onClick={accept}
              className="px-5 py-2.5 rounded-lg bg-[#2B7A9F] hover:bg-[#256b8c] text-white text-sm font-semibold transition-colors duration-300"
            >
              Accetta tutti
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
